import type { GetStreamingInfo200Drm } from './getStreamingInfo200Drm';
import type { GetStreamingInfo200MediaInfo } from './getStreamingInfo200MediaInfo';
import type { GetStreamingInfo200QualitiesItem } from './getStreamingInfo200QualitiesItem';
import type { GetStreamingInfo200Status } from './getStreamingInfo200Status';
import type { GetStreamingInfo200SupportedDevicesItem } from './getStreamingInfo200SupportedDevicesItem';

export type GetStreamingInfo200 = {
  /** DRM 정보 (있는 경우) */
  drm?: GetStreamingInfo200Drm;
  /** 전체 재생 시간 (초) */
  duration?: number;
  /** HLS 버전 */
  hlsVersion?: string;
  /** 미디어 파일 기본 정보 */
  mediaInfo?: GetStreamingInfo200MediaInfo;
  /** HLS 재생 목록 URL (m3u8) */
  playlistUrl?: string;
  /** 사용 가능한 품질 목록 */
  qualities?: GetStreamingInfo200QualitiesItem[];
  /** 각 세그먼트 재생 시간 (초) */
  segmentDuration?: number;
  /** 스트리밍 상태 */
  status?: GetStreamingInfo200Status;
  /** 스트리밍 기본 URL */
  streamUrl?: string;
  /** 스트리밍을 지원하는 장치 목록 */
  supportedDevices?: GetStreamingInfo200SupportedDevicesItem[];
  /** 총 세그먼트 수 */
  totalSegments?: number;
};
